import { instanceReports } from "../../../../services/instances";
import type {
  Category,
  GenerateReportParams,
  GetCategoriesParams,
  GetCategoriesReturn,
  GetReportsParams,
  GetReportsReturn,
  Report,
} from "../types/services";

const getCategories = async ({
  setLoading,
  body,
}: GetCategoriesParams): Promise<GetCategoriesReturn> => {
  let categoryIds: number[] = [];

  await instanceReports
    .post("/api/reportCategoryCompany/all", body)
    .then((response) => {
      categoryIds = response.data.result.map(
        (category: any) => category.category_id,
      );
    })
    .catch((error) => {
      console.error(error.message);
    });

  let categories: Category[] = [];

  await instanceReports
    .post("/api/report_category/all", {
      columns_select: ["*"],
      where_select: {
        id: `$FIND_IN_SET$${categoryIds.join(",")}`,
      },
    })
    .then((response) => {
      categories = response.data.result.map((category: any) => ({
        id: category.id,
        name: category.name,
      }));
    })
    .catch((error) => {
      console.error(error.message);
    })
    .finally(() => {
      setLoading(false);
    });

  return { categoryIds, categories };
};

const getReports = async ({
  setLoading,
  body,
}: GetReportsParams): Promise<GetReportsReturn> => {
  setLoading(true);

  let reports: Report[] = [];

  await instanceReports
    .post("/api/reports/all", body)
    .then((response) => {
      reports = response.data.result.map((report: any) => ({
        id: report.id,
        name: report.name,
        status: report.status,
        for_employees: report.for_employees,
        description: report.description,
        slug: report.slug,
        category_id: report.category_id,
      }));
    })
    .catch((error) => {
      console.error(error.message);
    })
    .finally(() => {
      setLoading(false);
    });

  return { reports };
};

const generateReport = async ({ body }: GenerateReportParams): Promise<any> => {
  return await instanceReports.post("/reports/api/execute", body);
};

export { getCategories, getReports, generateReport };
